import { Card, Empty, Spin, Table, Tag, Typography } from 'antd'
import { ColumnsType } from 'antd/es/table';
import { useEffect, useState } from 'react'
import { ReleaseUpdateTypes } from '../../Services/UpdatesService';
import dayjs from 'dayjs';
import { LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import DashboardService from '../../Services/DashboardService';
import { EmptyIcon } from '../../Common/FullPageSpinner';

interface DataType {
    key: string;
    version: string;
    date: string;
    title: string;
    type: string;
}

interface IProps{
    fromDate:string,
    toDate:string
}
const UpdateCard = ({fromDate,toDate}:IProps) => {
    const [loading,setLoading] = useState(false);
    const [updateData,setUpdateData] = useState<DataType[]>([])
    const [totalUpdate,setTotalUpdate] = useState(0)

    const updatesColumns:ColumnsType<DataType> = [
        {
            title: <span style={{ fontSize: '13px' }}>Version</span>,
            dataIndex: "version",
            key: "version",
            width: '12%',
        },
        {
            title: <span style={{ fontSize: '13px' }}>Date</span>,
            dataIndex: "date",
            key: "date",
            width:"18%",
            render:(itm)=>{
                return dayjs(itm).format("DD/MM/YYYY")
            }
        },
        {
            title: <span style={{ fontSize: '13px' }}>Title</span>,
            dataIndex: "title",
            key: "title",
            width: '50%',
            render: (text: string) => (
            <Typography.Text
                ellipsis={{
                tooltip: {
                    title: text,
                    placement: 'topLeft'
                }
                }}
            >
                {text}
            </Typography.Text>
            ),
        },
        {
            title: <span style={{ fontSize: '13px' }}>Type</span>,
            dataIndex: 'type',
            key: 'type',
            width:"20%",
            render: (type: string) => {
                const color = type === 'Enhancement' ? 'blue' : type === 'Development' ? 'green' : 'orange';
                return <Tag color={color}>{type}</Tag>;
            },
        },

    ];


    const getUpdateList = async () => {
        try {
            setLoading(true);
            const res = await DashboardService.getUpdateDetails(fromDate,toDate,0,10,"Date","descend")
            if(res?.result && res?.result?.items && res?.status){
                let updateList:DataType[] = res?.result?.items?.map((e:any)=>(
                    {
                        key: e?.id,
                        version: e?.version,
                        date: e?.date,
                        title: e?.title,
                        type: ReleaseUpdateTypes[e?.type]
                    }
                )) || [] 
                setUpdateData(updateList)
                setTotalUpdate(res?.result?.totalRecords || 0)
            }
            else{
                setUpdateData([])
            }

        } catch (error) {
            console.error(error)
        }
        finally{
            setLoading(false);
        }
    }

    useEffect(()=>{
        getUpdateList()
    },[fromDate,toDate])


    return (
        <Card
              title={<span className="fs15 fw600">Updates <span className="px-2 ms-1" style={{ background: '#377DFF', height: 17, color: '#ffffff',fontSize:13, borderRadius:10 }}>{updateData.length}</span></span>}
              // style={{ minHeight: 540 }}
              extra={
                <Link  style={{ color: '#377DFF' }} to="/updates" target="_blank">View All</Link>
            }
              style={{
                width: "100%",
                maxHeight: 538,
                display: "flex",
                flexDirection: "column"
              }}
              styles={{
                body: {
                  padding: "10px 16px",
                  flex: 1
                }
              }}
            >
                <Spin
                    spinning={loading}
                    indicator={<LoadingOutlined style={{ fontSize: 30 }} spin />}
                >
                    {updateData && updateData.length > 0 ? (
                        <Table
                            tableLayout="fixed"
                            columns={updatesColumns}
                            dataSource={updateData}
                            pagination={false}
                            size="small"
                        />
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 20, gap: 8 }}>
                            <EmptyIcon  />
                        </div>   
                    )}
                </Spin>
            </Card>
    )
}

export default UpdateCard